<template>
  <v-container fluid class="e-min-height  primary-gradiente" style="padding-top: 65px;">
    <Diccionario :id_unit="this.idUnidad" :isPractice="true"/>
    <v-layout row wrap class="fill-height" style="min-height: calc(100vh - 96px);">
      <v-flex xs12>
        <v-layout column>
          <HeaderFill title="Práctica Básica" :router="`/unidad/detalle/${this.idUnidad}`" />
          <CardIntro title="Práctica Básica" :router="`/practica/${this.idUnidad}/comenzar`"/>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import CardIntro from '../../../components/Practica/Global/CardIntro'
export default {
  name: 'practica',
  props: ['idUnidad'],
  components: {
    CardIntro
  }
}
</script>
